export default {
  prd: 'http://cooperativadospinos.researchmobile.co',
  qa: 'http://cooperativadospinos.researchmobile.co'
}




// WEBPACK FOOTER //
// ./src/config/index.js